import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ChevronDown, Globe } from 'lucide-react';

export default function LanguageSwitcher() {
  const { languages, lang, changeLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  if (!languages?.length) return null;
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <div ref={ref} className="relative">
      <button onClick={() => setOpen((s) => !s)} className="inline-flex items-center gap-2 text-[10.4px] uppercase tracking-[0.22em] text-[#C6C4CF] hover:text-[#FAF6EF] transition-colors">
        <Globe size={11} />
        <span>{current?.code}</span>
        <ChevronDown size={10} />
      </button>
      {open && (
        <div className="absolute right-0 mt-3 min-w-[180px] rounded-md bg-[#1E1E1E] border border-[#3A332A] py-2 z-50 shadow-2xl">
          {languages.map((l) => (
            <button key={l.code} onClick={() => { changeLang(l.code); setOpen(false); }} className={`w-full text-left px-4 py-2 text-sm transition-colors hover:bg-[#2A2A2A] ${l.code === lang ? 'text-[#C6C4CF]' : 'text-[#FAF6EF]'}`}>
              <span className="uppercase tracking-widest text-xs mr-3 text-[#8A8275]">{l.code}</span>
              {l.native_name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
